import { useDispatch } from "react-redux";

import { deregisterForOH, registerForOH } from "../../slices/openHousesSlice";

export const useOHBehavior = () => {
  const dispatch = useDispatch();

  return {
    register: ohId => dispatch(registerForOH(ohId)),
    deregister: ohId => dispatch(deregisterForOH(ohId))
  };
};
